import Message from './SpecialObject';

export default Message;